import React from 'react';
import { Box } from '@material-ui/core';
import getPreviewDomProps from '../getPreviewDomProps';
import { SampleFacets } from './IllustrativeContent';

/**
 * Facets Block Component
 * Schematic sidebar representation with dynamic limitFacets
 *
 * This preview shows the effect of limitFacets - the number of values
 * visible in each facet before "Show more" button
 */
const Facets = ({
  illustrative = false,
  collapseIgnore = [],
  collapseKeepOpened = 12,
  limitFacets = 5,
  theme,
  ...props
}) => {
  if (illustrative) return <SampleFacets {...{ limitFacets, collapseKeepOpened, collapseIgnore }} />;
  const primaryColor = theme?.palette?.primary?.main || '#e0e0e0';
  const domProps = getPreviewDomProps(props);

  // Stable widths for visual variety
  const widths = [65, 80, 72, 55, 78, 45, 70, 90, 75];

  // Total number of facet groups to display
  const totalFacetGroups = 5;

  // Maximum possible values per facet (for "Show more" indicator)
  const maxValuesPerFacet = 8;

  return (
    <Box display="flex" flexDirection="column" {...domProps}>
      {Array.from({ length: totalFacetGroups }).map((_, facetIndex) => {
        // Show limitFacets values, capped at a reasonable maximum for preview
        const optionsToShow = Math.min(limitFacets, maxValuesPerFacet);
        // Show "Show more" indicator if there would be more values
        const hasMoreValues = optionsToShow < maxValuesPerFacet;

        return (
          // eslint-disable-next-line react/no-array-index-key
          <Box key={`facet-group-${facetIndex}`} display="flex" flexDirection="column" marginBottom={4}>
            {/* Facet Title */}
            <Box display="flex" justifyContent="space-between" alignItems="center" marginBottom={2}>
              <Box width={90} height={12} bgcolor="#bdbdbd" borderRadius={2} />
              <Box width={12} height={12} bgcolor="#eeeeee" borderRadius="50%" />
            </Box>

            {/* Facet Options */}
            {Array.from({ length: optionsToShow }).map((__, i) => (
              // eslint-disable-next-line react/no-array-index-key
              <Box key={`opt-${facetIndex}-${i}`} display="flex" alignItems="center" marginBottom={1.5}>
                <Box width={18} height={18} bgcolor="#f5f5f5" borderRadius={3} border="1px solid #e0e0e0" marginRight={2} />
                <Box
                  height={10}
                  width={widths[(facetIndex * 3 + i) % widths.length]}
                  bgcolor="#eeeeee"
                  borderRadius={2}
                  marginRight={2}
                />
                <Box width={20} height={8} bgcolor="#f5f5f5" borderRadius={4} marginLeft="auto" opacity={0.6} />
              </Box>
            ))}

            {/* Show "Show more" indicator if there would be more items */}
            {hasMoreValues && (
              <Box
                display="flex"
                alignItems="center"
                marginTop={1}
                marginLeft={4}
              >
                <Box
                  height={8}
                  width={60}
                  bgcolor={primaryColor}
                  borderRadius={2}
                  opacity={0.7}
                />
              </Box>
            )}
          </Box>
        );
      })}
    </Box>
  );
};

export default Facets;
